import * as React from 'react';
import { AppState } from '../../store/reducers';
import { connect } from 'react-redux';
import UploadArea from './components/UploadArea';
import { uploadMedia } from '../../store/Entities/Media/media.actions';
import {
  getMediaItemByZoneId,
  MediaItem,
  uploadFailedForZoneId,
} from '../../store/Entities/Media/media.reducer';
import { showSnackbar } from '../../store/Snackbar/snackbar.actions';
import { SnackbarTypes } from '../../store/Snackbar/snackbar.reducer';
import Dropzone from 'react-dropzone';
import { length, forEach } from 'ramda';

interface State {
  isDragActive: boolean;
  isDragReject: boolean;
  acceptedFiles?: DropzoneFile[];
  rejectedFiles?: DropzoneFile[];
  dropzoneActive: boolean;
  acceptedTypes: string[];
}

export interface DropzoneFile {
  preview: string;
  lastModified: string;
  lastModifiedDate: string;
  name: string;
  size: number;
  type: string;
  webkitRelativePath: string;
}

interface OwnProps {
  zoneId: string;
  onUploaded?: (mediaItem: MediaItem) => any;
  width?: number;
  height?: number;
  acceptedTypes?: string[];
}

interface StateProps {
  mediaItems: MediaItem[];
  uploadFailed: boolean;
}

const ACCEPTED_MIME_TYPES = ['image/jpeg', 'image/png'];
const MIN_FILE_SIZE = 0;
const MAX_FILE_SIZE = 5242880; // 5MB

type Props = OwnProps & StateProps & typeof mapeDispatchToProps;
class MediaDropzone extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      acceptedFiles: void 0,
      rejectedFiles: void 0,
      isDragActive: false,
      isDragReject: false,
      dropzoneActive: false,
      acceptedTypes: props.acceptedTypes ? props.acceptedTypes : ACCEPTED_MIME_TYPES,
    };
  }

  private showSnackbar = (message: string, type: SnackbarTypes): void => {
    const { onShowSnackbar } = this.props;
    onShowSnackbar({ message, type });
  };

  private onDrop = (accepted: any, rejected: any) => {
    const { onAcceptedFileDrop, zoneId } = this.props;
    this.setState({
      acceptedFiles: accepted,
      rejectedFiles: rejected,
    });
    if (length(accepted) > 0) {
      onAcceptedFileDrop({
        file: accepted[0],
        zoneId,
      });
    } else {
      this.showSnackbar('Invalid filetype or image too large.', 'error');
    }
  };

  private onDragEnter = () => {
    this.setState({
      dropzoneActive: true,
    });
  };

  private onDragLeave = () => {
    this.setState({
      dropzoneActive: false,
    });
  };

  private onReset = () => {
    this.setState({
      acceptedFiles: void 0,
    });
  };

  private releasePreview = () => {
    const { acceptedFiles } = this.state;
    if (acceptedFiles) {
      forEach((file: DropzoneFile) => {
        window.URL.revokeObjectURL(file.preview);
      }, acceptedFiles);
    }
  };

  private fileWasUploaded = (mediaItem: MediaItem) => {
    const { onUploaded } = this.props;
    if (onUploaded && mediaItem) {
      onUploaded(mediaItem);
    }
  };

  public render() {
    const {
      isDragActive,
      isDragReject,
      acceptedFiles,
      rejectedFiles,
      acceptedTypes,
    } = this.state;
    const { mediaItems, uploadFailed, width, height } = this.props;

    if (mediaItems) {
      this.releasePreview();
    }

    return (
      <Dropzone
        activeStyle={{ backgroundColor: '#5f7d8c' }}
        multiple={false}
        onDrop={this.onDrop}
        accept={acceptedTypes.join(',')}
        minSize={MIN_FILE_SIZE}
        maxSize={MAX_FILE_SIZE}
        onDragEnter={this.onDragEnter}
        onDragLeave={this.onDragLeave}
        style={{ marginTop: 10 }}
      >
        <UploadArea
          isDragActive={isDragActive}
          isDragReject={isDragReject}
          acceptedFiles={acceptedFiles}
          rejectedFiles={rejectedFiles}
          acceptedTypes={acceptedTypes}
          onReset={this.onReset}
          mediaItem={mediaItems}
          uploadFailed={uploadFailed}
          onUploaded={(mediaItem: MediaItem) => this.fileWasUploaded(mediaItem)}
          width={width}
          height={height}
        />
      </Dropzone>
    );
  }
}

const mapStateToProps = (state: AppState, ownProps: OwnProps) => {
  return {
    mediaItems: getMediaItemByZoneId(state, ownProps.zoneId),
    uploadFailed: uploadFailedForZoneId(state, ownProps.zoneId),
  };
};

const mapeDispatchToProps = {
  onAcceptedFileDrop: uploadMedia,
  onShowSnackbar: showSnackbar,
};

export default connect(
  mapStateToProps,
  mapeDispatchToProps
)(MediaDropzone as any);



// WEBPACK FOOTER //
// ./src/modules/MediaDropzone/index.tsx